import {Fragment} from 'react';
import {getFromLocalStorage} from '@common/utils/hooks/local-storage';
import {PENDING_BIOLINK_NAME_KEY} from '@app/landing/landing-page-new-link-form';
import {useSettings} from '@common/core/settings/use-settings';
import {LaunchOfferBanner} from '@app/landing/launch-offer-banner';

export function RegisterExtraFields() {
  return (
    <Fragment>
      <LaunchOfferBanner className="mb-24" />
      <PendingBiolinkField />
    </Fragment>
  );
}

export function PendingBiolinkField() {
  const {base_url} = useSettings();
  const pendingName = getFromLocalStorage<string>(PENDING_BIOLINK_NAME_KEY);

  if (!pendingName) return null;

  const siteHost = base_url
    ? base_url.replace(/^https?:\/\//, '').replace(/\/$/, '')
    : window.location.hostname;

  return (
    <div className="mb-32">
      <div className="flex items-center gap-8 rounded-lg border border-primary/40 bg-primary/5 px-16 py-12">
        <svg
          className="shrink-0 text-primary"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
          <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </svg>
        <span className="text-sm">
          <span className="text-muted">Your biolink: </span>
          <span className="font-medium text-primary">
            {siteHost}/{pendingName}
          </span>
        </span>
      </div>
    </div>
  );
}
